module.exports = __webpack_public_path__ + "static/img/third3_2_active.33876102.png";